import React, { useState } from 'react';

const Pricing = () => {
  const [selectedMarket, setSelectedMarket] = useState('residential');

  const plans = {
    standard: {
      name: 'Standard',
      description: 'An out of the box solution giving you one powerful platform to run any property management business.',
      features: [
        'Property Accounting & Reports',
        'End-to-End Marketing & Leasing',
        'Work Order Management',
        'Inspections & Unit Turns',
        'Mobility & Convenience',
        'Portals & Communication',
        'Live Chat & Request a call'
      ]
    },
    plus: {
      name: 'Plus',
      description: 'A configurable solution for growing businesses with complex portfolios looking to standardize processes.',
      features: [
        'Everything in Standard, and:',
        'Affordable Housing Capabilities',
        'Student Housing Capabilities',
        'Advanced Budgeting & Accounting',
        'Advanced Data Analysis',
        'Custom Fields',
        'Premium Integrations',
        'Enhanced Support'
      ]
    },
    max: {
      name: 'Max',
      description: 'An enterprise solution for large operators that are focused on customization, data insights, and driving revenue.',
      features: [
        'Everything in Plus, and:',
        'Leasing CRM',
        'API Access',
        'Dedicated Customer Success Management',
        'Custom Reporting'
      ]
    }
  };

  return (
    <div style={{ padding: '60px 0' }}>
      <div className="container">
        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Full-Featured Property Management System</h2>
        <p style={{ textAlign: 'center', marginBottom: '40px', maxWidth: '800px', margin: '0 auto 40px' }}>
          Find the right fit for your rental property portfolio. With multiple pricing plans to choose from and opportunities to be flexible, get exactly what you need to operate at the top of your game.
        </p>

        <div style={{ marginBottom: '40px', textAlign: 'center' }}>
          <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Filter by Market:</label>
          <select 
            value={selectedMarket} 
            onChange={(e) => setSelectedMarket(e.target.value)}
            style={{ padding: '8px 12px', borderRadius: '4px', border: '1px solid #ddd' }}
          >
            <option value="residential">Residential</option>
            <option value="commercial">Commercial</option>
            <option value="mixed">Mixed Use</option>
          </select>
        </div>

        {selectedMarket === 'residential' && (
          <div>
            <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>Residential</h3>
            <p style={{ textAlign: 'center', marginBottom: '40px' }}>
              Run your entire rental portfolio on a single, modern platform. No matter the size of your business or the mix — multifamily, single-family, affordable housing — we offer multiple plans to match your rental needs.
            </p>
          </div>
        )}

        <div className="pricing-grid">
          {Object.entries(plans).map(([key, plan]) => (
            <div key={key} className="pricing-card">
              <h3>{plan.name}</h3>
              <p style={{ marginBottom: '20px', color: '#666' }}>{plan.description}</p>
              <ul className="feature-list">
                {plan.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
              <button className="btn btn-primary" style={{ marginTop: '20px' }}>
                Contact Us for Details
              </button>
            </div>
          ))}
        </div>

        <div style={{ marginTop: '60px', textAlign: 'center', background: '#f8f9fa', padding: '40px', borderRadius: '8px' }}>
          <h3>Customize Your Plan</h3>
          <p style={{ marginBottom: '30px' }}>
            Select value-added services to extend the productivity of your team, without compromising on the exceptional ease of use and functionality of one powerful platform.
          </p>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginTop: '30px' }}>
            <div style={{ background: 'white', padding: '20px', borderRadius: '6px' }}>
              <h4>AppFolio Realm-X Performers</h4>
              <p>Built-in agentic AI to independently observe, interpret, and act on signals from your data.</p>
            </div>
            <div style={{ background: 'white', padding: '20px', borderRadius: '6px' }}>
              <h4>Online Payments</h4>
              <p>Streamline all payments to and from your tenants, owners and vendors online.</p>
            </div>
            <div style={{ background: 'white', padding: '20px', borderRadius: '6px' }}>
              <h4>Screening & Verification</h4>
              <p>Improve the speed and quality of your leasing process with integrated screening.</p>
            </div>
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: '60px' }}>
          <h3>Talk With an Expert</h3>
          <p style={{ marginBottom: '20px' }}>Learn more about what we can do for your business. Our product experts are available to chat whenever you have questions.</p>
          <button className="btn btn-primary">Contact Us Today</button>
        </div>
      </div>
    </div>
  );
};

export default Pricing;